import { GoldButton } from './Shared';
import { fillCount, surveyProgress } from '../survey';
import artSurvey from '../assets/art_survey.webp';
import chestc from '../assets/chestc.webp';

/* ------------------------------------------------------------------
   "Bonus rewards" · the quick-survey card on the hub, laid out like a
   streak card (prototype .card.svcard). Three states from `state.status`:
   - new  : "Free Chest" chip, the reward line, "Take the survey"
   - part : "In progress" chip, how far they got (mini bars), "Resume survey"
   - done : "Claimed" chip, "Golden Chest claimed", outlined done CTA
   `survey` is the mapped API survey (copy + questions); `onStart` opens
   the survey screen.
   ------------------------------------------------------------------ */

/* "Let's make your money work for you" → "…for you." */
const sentence = (s) => (s && !/[.!?…]$/.test(s) ? `${s}.` : s || '');

export default function SurveyCard({ survey, state, onStart }) {
  const { copy } = survey;
  const done = state.status === 'done';
  const part = state.status === 'part';
  const pr = part ? surveyProgress(survey, state) : null;

  let chip;
  if (done) {
    chip = (
      <>
        <svg viewBox="0 0 11 11" fill="none" aria-hidden="true"><path d="M2 5.6l2.3 2.3L9 3.4" stroke="#fff" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" /></svg>
        <span>Claimed</span>
      </>
    );
  } else if (part) {
    chip = <><span className="gq-pdot" /><span>In progress</span></>;
  } else {
    chip = <><img src={chestc} alt="" /><span>Free Chest</span></>;
  }

  return (
    <div className={`gq-card gq-svcard${done ? ' gq-done' : ''}${part ? ' gq-part' : ''}`}>
      <div className="gq-tile"><img src={artSurvey} alt="" /></div>
      <div className="gq-t gq-ttl">Quick survey</div>
      <div className="gq-txt">
        <div className="gq-desc">{part ? sentence(fillCount(copy.resumeTitle, pr.rem)) : sentence(copy.title)}</div>
        <div className="gq-fine">{part ? 'Your answers are saved.' : sentence(copy.duration)}</div>
      </div>
      <div className="gq-lockchip gq-svchip">{chip}</div>
      <div className="gq-divider" />

      <div className="gq-rwd">
        {part ? (
          <>
            <div className="gq-mini" aria-hidden="true">
              {Array.from({ length: pr.total }, (_, k) => <i key={k} className={k < pr.done ? 'gq-on' : ''} />)}
            </div>
            <span>{pr.done} of {pr.total} answered · Golden Chest waiting</span>
          </>
        ) : (
          <>
            <img className="gq-ci" src={chestc} alt="" />
            <span>{done ? 'Golden Chest claimed' : copy.reward}</span>
          </>
        )}
      </div>

      {done
        ? <GoldButton done>Survey done · Thank you!</GoldButton>
        : <GoldButton onClick={onStart}>{part ? copy.resumeCta : 'Take the survey'}</GoldButton>}
    </div>
  );
}
